import React, { useContext, useMemo } from "react";
import { StyleSheet, View } from "react-native";
import { PlayerContext } from "../backend/PlayerContext";
import { getActionsForAreaByCategory } from "../backend/actions/Actions";
import { getFirstHint } from "../backend/hints/Hints";
import ActionsContainer from "./utility/ActionsContainer";
import { Text } from "./utility/Text";

export default function Upgrades() {
  const playerContext = useContext(PlayerContext);
  const currentHint = getFirstHint(playerContext);

  const allActionsMaxedOut = !Object.values(
    getActionsForAreaByCategory("Upgrades"),
  )
    .map((actionRecord) => Object.values(actionRecord))
    .flat()
    .some((action) => {
      return action.isVisible(playerContext);
    });

  const showUpgradesHint =
    allActionsMaxedOut &&
    ![
      "Enjoy basking in the glory of the institution you have built",
      "You have completed the demo! Please purchase the full game to continue, or retire to start again",
      "Explore the Garden of Creation",
      "Defeat the Creator",
      "Win the Tournament of Magic",
      "Explore the Wizard's Arena",
    ].includes(currentHint?.description ?? "");

  const upgradesHint = useMemo(() => {
    if (showUpgradesHint) {
      return "You have purchased all the upgrades available to you! But you may find more if you make progress in Exploration...";
    }
    return "You have purchased all the upgrades available to you!";
  }, [showUpgradesHint]);
  return (
    <View style={styles.container}>
      {allActionsMaxedOut && (
        <View style={styles.hintWarningContainer}>
          <Text style={styles.hintWarningText}>{upgradesHint}</Text>
        </View>
      )}
      <ActionsContainer area="Upgrades" />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "stretch",
    justifyContent: "flex-start",
    width: "100%",
  },
  hintWarningContainer: {
    marginTop: 16,
  },
  hintWarningText: {
    fontStyle: "italic",
  },
});
